export const encodeShareCode = (code: string): string => {
  return code
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-');
};
